export function cookiePopup() {
    const body = document.body;
    const cookies = document.querySelector(".cookie-popup");

    if (cookies) {
        let acceptCookie = cookies.querySelector(".close");
        body.classList.add("cookies-visible");

        if (document.cookie.indexOf("cookiesAccess=") >= 0) {
            cookies.style.display = "none";
            body.classList.add("cookies-hide");
            body.classList.remove("cookies-visible");
        } else {
            cookies.style.display = "flex";
            body.classList.remove("cookies-hide");
        }

        acceptCookie.addEventListener("click", function (e) {
            e.preventDefault();

            let expiry = new Date();
            expiry.setTime(expiry.getTime() + 3600000*24*14);
            document.cookie = "cookiesAccess=yes; path=/; expires=" + expiry.toGMTString();
            body.classList.add("cookies-hide");
            body.classList.remove("cookies-visible");
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/cookiePopup.js